// extracted by mini-css-extract-plugin
export default {"price-detail":"styles_price-detail__w7Ih7","price-detail__line":"styles_price-detail__line__bHkdt"};